import { LoggedUser } from './../core/logged/logged.model';
import { PaginatedPoi } from './../shared/models/paginated-poi.model';
import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, mergeMap, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { Observable, of } from 'rxjs';
import { PoiActionService } from '../core/poi/poi.action';
import { select } from '@angular-redux/store';

@Injectable()
export class PoiListUnapprovedAdminResolver implements Resolve<any> {
  @select(['logged', 'logged'])
  userLogged$: Observable<LoggedUser>;

  constructor(private service: ApiService,
              private poiAction: PoiActionService) {}

  resolve() {
    return this.userLogged$.pipe(
      first(),
      mergeMap((user: LoggedUser) => {
        const geoposId = user.auth_user === 'superadmin' ? null : user.geopos[0].id;
        return this.service.getPoi(
          0,
          geoposId,
          null,
          null,
          null,
          false
        ).pipe(first());
      }),
      tap((paginatedPoi: PaginatedPoi) => {
        this.poiAction.paginatedPoiList(paginatedPoi);
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare la lista di POI');
        return of(err);
      })
    );
  }
}
